import React from 'react';

export const GOOGLE_REVIEW_URL = 'https://g.page/r/CWlTm2ujJPBvEBI/review';
const GOOGLE_REVIEW_ICON = '/branding/social/googlereview.png';

export default function GoogleReviewCTA({ compact = false, subtle = false }) {
  return (
    <section className={subtle ? 'py-8 px-4' : compact ? 'py-12 px-4' : 'py-16 px-4'} style={{ backgroundColor: '#FEFEFD' }}>
      <div className="max-w-5xl mx-auto">
        <div className={subtle ? 'rounded-xl border p-4 md:p-5' : 'rounded-2xl border p-6 md:p-8'}
          style={{ backgroundColor: subtle ? '#FAF8F4' : '#F7F5F1', borderColor: '#dbd7d0' }}>
          <div className={subtle ? 'grid grid-cols-1 md:grid-cols-[auto_1fr] gap-3 md:gap-4 items-center' : 'grid grid-cols-1 md:grid-cols-[auto_1fr] gap-4 md:gap-6 items-center'}>
            <img
              src={GOOGLE_REVIEW_ICON}
              alt="Google Reviews"
              width="560"
              height="249"
              className={subtle ? 'w-28 md:w-32 h-auto object-contain' : 'w-36 md:w-44 h-auto object-contain'}
              loading="lazy"
              decoding="async"
            />

            <div>
              <div className={subtle ? 'inline-flex items-center gap-2 mb-2' : 'inline-flex items-center gap-2 mb-3'}>
                <span className="h-px w-6" style={{ backgroundColor: '#B89547' }}></span>
                <span className="text-xs font-semibold tracking-[0.2em] uppercase" style={{ color: '#B89547' }}>Google Reviews</span>
                <span className="h-px w-6" style={{ backgroundColor: '#B89547' }}></span>
              </div>
              <h3 className={subtle ? 'text-lg md:text-xl font-semibold mb-1.5' : 'text-2xl md:text-3xl font-semibold mb-2'} style={{ color: '#2E2C29' }}>
                A sua opinião ajuda-nos a crescer
              </h3>
              <div className={subtle ? 'flex flex-col sm:flex-row sm:items-center gap-2.5' : 'flex flex-col sm:flex-row sm:items-center gap-3'}>
                <a
                  href={GOOGLE_REVIEW_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={subtle
                    ? 'inline-flex items-center justify-center rounded-lg px-4 py-1.5 text-sm font-semibold transition self-start'
                    : 'inline-flex items-center justify-center rounded-lg px-5 py-2 text-sm font-semibold transition self-start'}
                  style={{
                    backgroundColor: subtle ? 'transparent' : '#B89547',
                    color: subtle ? '#9A7C38' : '#FEFEFD',
                    border: subtle ? '1px solid #DCCCA0' : 'none'
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.backgroundColor = '#9A7C38';
                    e.currentTarget.style.color = '#FEFEFD';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.backgroundColor = subtle ? 'transparent' : '#B89547';
                    e.currentTarget.style.color = subtle ? '#9A7C38' : '#FEFEFD';
                  }}
                >
                  Deixar Review
                </a>
                <p className={subtle ? 'text-sm' : 'text-sm md:text-base'} style={{ color: '#706b63' }}>
                  Se gostou da experiência, deixe a sua avaliação no Google. É rápido e faz toda a diferença.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
